import React from 'react';
import cn from 'classnames';
import UseResize from 'utils/hooks/useResize';
import style from './index.module.scss';

interface IProps {
  title?: string;
  desc?: string;
  features?: any[];
  bgImage?: string;
  bgImageM?: string;
  imgPre?: string;
  type?: number;
}

const Medias = (props: IProps) => {
  const size = UseResize();
  const { title = '', desc = '', features = [], bgImage = '', bgImageM = '', imgPre = '', type } = props;
  return (
    <div className={cn(style.media, type === 1 && style.media1)} style={{ backgroundImage: `url(${size.width < 768 ? `${imgPre}${bgImageM}` ?? `${imgPre}${bgImage}` : `${imgPre}${bgImage}`})` }}>
      <div className={style.content}>
        <div className={style.title}>{title}</div>
        <div className={style.desc} dangerouslySetInnerHTML={{ __html: desc.replace(/\n/g, '<br/>') }}></div>
        <div className={style.features}>
          {features.map((item: any, index: number) => {
            return (
              <div key={item.name} className={style.feature}>
                <img src={`${imgPre}feature-icon${index}.png`} alt="media" />
                <span className={style.name}>{item.name}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default Medias;
